import "./device.resource";
import { auth as authT } from "../../typings/auth";

class AuthDeviceDataService {
    public static $inject: string[] = ["authDeviceResource"];

    constructor(private authDeviceResource) {}

    public query(params) {
        return this.authDeviceResource().query(params).$promise;
    }

    public revoke(device) {
        return this.authDeviceResource().revoke(device).$promise;
    }

    public updateScopes({
        deviceId,
        body,
        granting
    }: {
        deviceId: string;
        body: { scopes: authT.Scopes[] };
        granting: boolean;
    }) {
        return granting
            ? this.authDeviceResource().postScopes({ deviceId }, body).$promise
            : this.authDeviceResource().deleteScopes({ deviceId }, body).$promise;
    }
}

angular
    .module("thor.core.auth.device-data-service", [
        "thor.core.auth.device.resource"
    ])
    .service("authDeviceDataService", AuthDeviceDataService);
